import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { DatatableComponent, SelectionType } from "@swimlane/ngx-datatable";
import { AuthService } from "app/base-module/base-service/auth.service";
import { IItemsPermissionActions } from "app/interfaces/IItemsPermissionActions";
import { FiltrarBoletaComponent } from "app/movimentacao/filtrar-boleta/filtrar-boleta.component";
import { ActionDialog, BaseComponent } from "../../base-module/base-component/base.component";
import { AtualizaStatusBoletaRendaFixaComponent } from "../atualiza-status-boleta-renda-fixa/atualiza-status-boleta-renda-fixa.component";
import { CadastroBoletaRendaFixaComponent } from "../cadastro-boleta-renda-fixa/cadastro-boleta-renda-fixa.component";
import { UploadRendaFixaComponent } from "../renda-fixa/upload-renda-fixa/upload-renda-fixa.component";
import { BoletaRendaFixaService } from "../services/boleta-rendafixa.service";

interface Actions {
    buttonNew: IItemsPermissionActions;
    buttonView: IItemsPermissionActions;
    buttonEdit: IItemsPermissionActions;
    buttonDelete: IItemsPermissionActions;
    buttonExport: IItemsPermissionActions;
    buttonEditStatus: IItemsPermissionActions;
}

@Component({
    selector: "app-lista-boleta-renda-fixa",
    templateUrl: "./lista-boleta-renda-fixa.component.html",
    styleUrls: ["./lista-boleta-renda-fixa.component.scss"]
})

export class ListaBoletaRendaFixaComponent extends BaseComponent implements OnInit{

    user:any;
    public search = new FormControl();
SelectionType = SelectionType;

    selected:any = [];
    data:any = {};
    titulo!:string;

    model: any = {
        status_id: "",
        boletas:[]
    };
    

    _actions: Actions = {
        buttonNew: {
            permission: "Cadastrar Boleta Renda Fixa",
            enabled: false
        },
        buttonView: {
            permission: "Visualizar Boleta Renda Fixa",
            enabled: false
        },
        buttonEdit: {
            permission: "Editar Boleta Renda Fixa",
            enabled: false
        },
        buttonDelete:{
            permission: "Excluir Boleta Renda Fixa",
            enabled: false
        },
        buttonExport:{
            permission: "Exportar Boleta Renda Fixa",
            enabled: false
        },
        buttonEditStatus:{
            permission: "Atualiza Status Boleta Renda Fixa",
            enabled: false
        }
    };
    
    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(DatatableComponent, { static: false }) table!: DatatableComponent;
    
    constructor(public service: BoletaRendaFixaService, 
                public dialog: MatDialog, 
                override snackBar: MatSnackBar, 
                private route: Router,
                private _authService: AuthService) {
        super(dialog, snackBar);        

        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser? strUser : "{}");
        this.search.setValue("");
        this.getAll();

    }

    ngOnInit(): void {
        this.verifyPermissionForActions();
    }

    verifyPermissionForActions(){

        this._actions.buttonDelete.enabled = this._authService
        .isPermissao([this._actions.buttonDelete.permission]);

        this._actions.buttonEdit.enabled = this._authService
        .isPermissao([this._actions.buttonEdit.permission]);

        this._actions.buttonView.enabled = this._authService
        .isPermissao([this._actions.buttonView.permission]);

        this._actions.buttonNew.enabled = this._authService
        .isPermissao([this._actions.buttonNew.permission]);

        this._actions.buttonExport.enabled = this._authService
        .isPermissao([this._actions.buttonExport.permission]);

        this._actions.buttonEditStatus.enabled = this._authService
        .isPermissao([this._actions.buttonEditStatus.permission]);
    }
    /**
     * Evento de ordenação da lista de produtos
     * @param event
     */
    onSort(event:any){

        this.params.sortColumn = event.column.prop;
        
        if(event.column.name == "Responsavel Operação"){
            this.params.sortColumn = "operador_id";
        }else if(event.column.name == "Escritório"){
            this.params.sortColumn = "escritorio_id";
        }else if(event.column.name == "Conta Cliente"){
            this.params.sortColumn = "numero_xp";
        }else if(event.column.name == "Cliente"){
            this.params.sortColumn = "nome_cliente";
        }else if(event.column.name == "Status"){
            this.params.sortColumn = "status_id";
        }        

        this.params.sortOrder = event.newValue;
        this.getAll();
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event:PageEvent){        

        this.params.page = (event.pageIndex+1);
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    getSaldo(row:any){
        return parseFloat(row.valor) - parseFloat(row.vlr_executado);
    }

    /**
     * Consulta lista de Boletas
     */
    getAll() {
        if(this.search.value != null){
            this.params.search = this.search.value;
        }

        this.loadingIndicator = true;
        this.service.getAll(this.params).subscribe(
            data => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            error => {                
                this.loadingIndicator = false;
                
                if(error.status == 401){        
                    this._authService.logout();
                    this.route.navigate(["/auth/login"]);
                }
            },
            () => {
                this.loadingIndicator = false;
            }
        );
    }

    /**
     * Exclui registro de boleta
     * @param id
     */
    delete(id: number) {

        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir boleta",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.loadingIndicator = true;
                    lista.service.delete(id).subscribe(
                        data => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        error => {
                            lista.loadingIndicator = false;                            
                            lista.showError(error.error.message);

                        },
                        () => {                            
                            lista.loadingIndicator = false;
                        }
                    );
                }
            }
        });
    }

    openCadastro(){
        const dialogRef = this.dialog.open(CadastroBoletaRendaFixaComponent, {
            width: "800px",
            maxHeight: "99vh",
            data: {
                acao_comercial_id: null,
                cliente_id: null,
                id: null
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(result);
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Boleta Renda Fixa cadastrada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar cadastrar uma nova boleta renda fixa.");
            }
        });        
    }

    openAlterar(id: number){
        const dialogRef = this.dialog.open(CadastroBoletaRendaFixaComponent, {
            width: "800px",
            maxHeight: "99vh",
            data: {
                acao_comercial_id: null,
                cliente_id: null,
                id: id
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(result);
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Boleta Renda Fixa atualizada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar atualizar um nova boleta Renda Fixa.");
            }
        });     
    }

    /**
     * Modal de Filtro
     */
    openFiltro(): void {
        const dialogRef = this.dialog.open(FiltrarBoletaComponent, {
            width: "700px",            
            maxHeight: "99vh",
            data: { 
                titulo: "Filtrar Boleta",
                status_boleta: true,
                status_ordem: false,
                tipo: "RF"
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != "cancel" && result != undefined) {
                
                this.params.data_operacao_inicio    = result.data_operacao_inicio;
                this.params.data_operacao_fim       = result.data_operacao_fim;
                
                if (result.cliente != undefined && result.cliente != null){
                    this.params.cliente_id = result.cliente.id;
                }else{
                    this.params.cliente_id = "";
                }

                if (result.assessor_id != undefined && result.assessor_id != null) {
                    this.params.assessor_id = result.assessor_id;
                }else{
                    this.params.assessor_id = "";
                }

                if (result.escritorio_id != undefined && result.escritorio_id != null) {
                    this.params.escritorio_id = result.escritorio_id;
                }else{
                    this.params.escritorio_id = "";
                }

                if (result.status_id != undefined && result.status_id != null) {
                    this.params.status_id = result.status_id;
                }else{
                    this.params.status_id = "";
                }

                if (result.acao_comercial_id != undefined && result.acao_comercial_id != null) {
                    this.params.acao_comercial_id = result.acao_comercial_id;
                }

                if (result.compra_venda != undefined && result.compra_venda != null) {
                    this.params.compra_venda = result.compra_venda;
                }
                
                if (result.produto_id != undefined && result.produto_id != null) {
                    this.params.produto_id = result.produto_id;
                }else{
                    this.params.produto_id = "";
                }

                this.paginator.firstPage();
                this.getAll();
            }
        });
    }

    onSelect({ selected }:any) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }
    /**
     * Consulta lista
     */
    getAllExport() {

        this.openLoading();
        this.service.getAllExport(this.params).subscribe(
            data => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");

            },
            error => {                
                this.closeLoading();
            },
            () => {                
                this.closeLoading();
            }
        );
    }

    getEscritorioCliente(cliente:any){
        if(cliente.escritorio !=undefined && cliente.escritorio != ""){
            return cliente.escritorio.nome_fantasia;
        }

        return "";
    }

    getAssessorCliente(cliente:any){
        if(cliente.assessor !=undefined && cliente.assessor != ""){
            return cliente.assessor.name;
        }

        return "";
    }

    openUpload() : void {
        const dialogRef = this.dialog.open(UploadRendaFixaComponent, {
            width: "400px",  
            data:{
                url: "rendafixa/boleta-renda-fixa/upload",
                title: "Upload dos Renda Fixa"
            }        
        });

        dialogRef.afterClosed().subscribe((result: any) => {            
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Renda Fixa atualizada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar atualizar o(s) registro(s)");
            }
        });
    }

    /**
     * Consulta lista
     */
    downloadAnexo(id:number) {

        //this.openLoading();
        this.service.download(id).subscribe(
            data => {

                const blob = new Blob([data]);
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");

            },
            error => {
                console.log(error);
                //this.closeLoading();
            },
            () => {

                console.log("complete");
                //this.closeLoading();
            }
        );
    }

    openAtualizarStatus(): void {

        if(this.selected.length == 0){
            this.showError("Selecione pelo menos uma boleta para realizar a atualização do status");
            return;
        }

        const dialogRef = this.dialog.open(AtualizaStatusBoletaRendaFixaComponent, {
            width: "700px",
            data: { 
                boletas: this.selected,
                tipo: "RV"
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != "cancel" && result != undefined) {
                this.getAll();
                this.selected = [];
            }
        });
    }
}
